const MeaStudentGender = ({ gender, className, size }) => {
  //
  const getGender = (size) => {
    if (gender === "G") {
      return <i className="pi pi-venus" style={{ color: "pink", fontSize: size }}>Fille</i>;
    } else if (gender === "B") {
      return <i className="pi pi-mars" style={{ color: "blue", fontSize: size || "1rem" }}>Garçon</i>;
    } else {
      return <i className="pi pi-question" style={{ fontSize: size || "1rem" }}>Inconnu</i>;
    }
  };
  //
  return (
    <div className={className}>
      {getGender(size)}
    </div>
  );
};

export default MeaStudentGender;